export enum ConfigurationOptionsPriceFormationEnum 
{
    Markup = 13,
    Margin = 14,
}